/**
 * ElevenLabs im Haus: wer es hören darf und was die Hörprobe spricht.
 * (07.10.2026, Prüfrunde der Bahn eleven-server)
 *
 * ⚠️ WER: nur Konto 1, der Betreiber — dieselbe Regel wie für die Meditation
 *    (shared/meditations-stimme.ts, meditationElevenWaehlbar). EINE Funktion
 *    für alles, was den ElevenLabs-Schlüssel des Betreibers belastet: die
 *    Meditation, ihre Hörprobe und jede ElevenLabs-Stimme in
 *    /api/voice-preview. Vorher entschied das nur die Einstellungsseite (sie
 *    blendet ElevenLabs für andere Konten aus) — am Server konnte jedes
 *    angemeldete Konto mit einer ElevenLabs-Kennung auf Martins Guthaben
 *    vertonen.
 *
 * ⚠️ WAS: Die Hörprobe der Meditationsstimme spricht EINEN festen Satz. Der
 *    Server nimmt für `zweck: MEDITATIONS_PROBE_ZWECK` nur diesen Satz, gleich
 *    was im Körper steht — kein freier Text auf ElevenLabs-Guthaben. Die
 *    Einstellungsseite nimmt ihn von hier, statt ihn ein zweites Mal zu schreiben.
 *
 * Rein (kein Node): Server und Seite rechnen mit denselben Werten.
 */
import { istElevenStimmKennung, meditationElevenWaehlbar } from "./meditations-stimme.js";

/** Darf dieses Konto ElevenLabs hören? Dieselbe Regel wie die Meditation (nur Konto 1). Rein. */
export function darfElevenLabs(userId: number | null | undefined): boolean {
  return meditationElevenWaehlbar(userId);
}

/**
 * Ist das eine AUSDRÜCKLICH gewählte ElevenLabs-Stimme, die dieses Konto
 * nicht hören darf? Rein. (07.10.2026, Prüfrunde)
 *
 * Für jeden Einstieg, an dem eine Stimme aus der Anfrage, den Einstellungen
 * oder vom Modell kommt (Vorlesen, Erzählen, Projekt-MP3, Werkzeug,
 * Hintergrund-Vertonungen) — Liste in PLAN-ELEVEN-V4.md.
 *
 * ⚠️ Nur die GEWÄHLTE Stimme. Rückfallketten (etwa „Im Rückfall gilt
 *    ElevenLabs auch dann, wenn es sonst abgeschaltet ist" in
 *    server/tts-stream.ts) bleiben, wie sie sind.
 * ⚠️ ElevenLabs-Kennungen haben 20 Zeichen (istElevenStimmKennung). Eine
 *    andere Zeichenkette lehnt ElevenLabs selbst ab, ohne Guthaben zu kosten.
 */
export function elevenLabsVerweigert(voiceId: unknown, userId: number | null | undefined): boolean {
  return istElevenStimmKennung(typeof voiceId === "string" ? voiceId.trim() : voiceId) && !darfElevenLabs(userId);
}

/** Der ehrliche Satz für eine Absage — EINE Stelle für alle Einstiege. */
export const ELEVENLABS_NUR_BETREIBER =
  "ElevenLabs-Stimmen gibt es nur im Konto des Betreibers — bitte eine Soniox- oder Gemini-Stimme wählen.";

/** Der Satz der Hörprobe — ruhig, kurz, wie die Meditation klingt (118 Zeichen). */
export const MEDITATIONS_PROBE =
  "Atme ruhig ein … und lass den Atem ganz langsam wieder gehen. Du musst gerade nichts tun. Du darfst einfach hier sein.";

/** Was die Probe-Anfrage dem Server sagt: diese Probe ist für die Meditation (er wählt das Modell). */
export const MEDITATIONS_PROBE_ZWECK = "meditation";
